// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); /* Fondo negro semi-transparente */
    z-index: 999; /* Asegura que esté detrás del modal */
  }
  
  /* Modal: Contenedor principal */
  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 8px #0000001a;
    padding: 40px;
    width: 500px;
    z-index: 1000; /* Debe estar encima de la overlay */
    height: 80vh;
    overflow-y: auto; /* Permite scroll si el contenido es muy grande */
  }

  
/* Header del Modal */
.modal h2 {
    margin-bottom: 15px;
    text-align: center;
    color: #747070;
    font-size: 16px;
  }
  
  /* Inputs, Textareas y Select */
  .modal input,
  .modal textarea,
  .modal select {
    width: 100%;
    padding: 5px;
    margin: 8px 0;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 12px;
    resize: none;
  }

.modal label{
  font-size: 12px;
}
  
/* Contenedor de Tags */
.tag-container {
    margin-bottom: 10px;
    margin-top: 10px;
    background-color: #f1f1f1;
    padding: 20px;
    border-radius: 5px;
    overflow-y: auto;
    max-height: 100px;
  }
  
  /* Estilo para cada Tag */
  .tag {
    display: inline-block;
    background-color: #79b4f4;
    color: white;
    padding: 5px 10px;
    border-radius: 15px;
    margin-right: 10px;
    margin-bottom: 5px;
    font-size: 12px;
  }
  
  .remove-tag{
    border-style: none;
    background-color:transparent;
    color: white;
    margin-left: 10px;
    padding: 0;
  }

  .remove-tag:hover{
    transform: scale(1.5);
    color: rgb(217, 31, 31);
    cursor: pointer;
  }

  /* Botón de Añadir */
.add-group-button {
    margin-top: 10px;
    padding: 10px;
    width: 50%;
    background-color: #aacaec;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  /* Botón de Añadir */
.add-host-button {
    margin-top: 10px;
    padding: 10px;
    width: 50%;
    background-color: #aacaec;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }


  /* Botón de Añadir */
.add-user-button {
    margin-top: 10px;
    padding: 10px;
    width: 50%;
    background-color: #aacaec;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .add-user-button:hover{
    background-color: #4d86c3;
  }
  .add-group-button:hover{
    background-color: #4d86c3;
  }
  .add-host-button:hover{
    background-color: #4d86c3;
  }

  .cancel-button{
    margin-right: 25px;
    border-radius: 5px;
    padding: 8px;
  }`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/Maintenance/Maintenance-styles/modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC,EAAE,kCAAkC;IACxE,YAAY,EAAE,sCAAsC;EACtD;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,aAAa,EAAE,oCAAoC;IACnD,YAAY;IACZ,gBAAgB,EAAE,iDAAiD;EACrE;;;AAGF,qBAAqB;AACrB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;;;IAGE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;AAEF;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;EACjB;;EAEA,oBAAoB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA,oBAAoB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;;EAGA,oBAAoB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5); /* Fondo negro semi-transparente */\n    z-index: 999; /* Asegura que esté detrás del modal */\n  }\n  \n  /* Modal: Contenedor principal */\n  .modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px #0000001a;\n    padding: 40px;\n    width: 500px;\n    z-index: 1000; /* Debe estar encima de la overlay */\n    height: 80vh;\n    overflow-y: auto; /* Permite scroll si el contenido es muy grande */\n  }\n\n  \n/* Header del Modal */\n.modal h2 {\n    margin-bottom: 15px;\n    text-align: center;\n    color: #747070;\n    font-size: 16px;\n  }\n  \n  /* Inputs, Textareas y Select */\n  .modal input,\n  .modal textarea,\n  .modal select {\n    width: 100%;\n    padding: 5px;\n    margin: 8px 0;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 12px;\n    resize: none;\n  }\n\n.modal label{\n  font-size: 12px;\n}\n  \n/* Contenedor de Tags */\n.tag-container {\n    margin-bottom: 10px;\n    margin-top: 10px;\n    background-color: #f1f1f1;\n    padding: 20px;\n    border-radius: 5px;\n    overflow-y: auto;\n    max-height: 100px;\n  }\n  \n  /* Estilo para cada Tag */\n  .tag {\n    display: inline-block;\n    background-color: #79b4f4;\n    color: white;\n    padding: 5px 10px;\n    border-radius: 15px;\n    margin-right: 10px;\n    margin-bottom: 5px;\n    font-size: 12px;\n  }\n  \n  .remove-tag{\n    border-style: none;\n    background-color:transparent;\n    color: white;\n    margin-left: 10px;\n    padding: 0;\n  }\n\n  .remove-tag:hover{\n    transform: scale(1.5);\n    color: rgb(217, 31, 31);\n    cursor: pointer;\n  }\n\n  /* Botón de Añadir */\n.add-group-button {\n    margin-top: 10px;\n    padding: 10px;\n    width: 50%;\n    background-color: #aacaec;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n\n  /* Botón de Añadir */\n.add-host-button {\n    margin-top: 10px;\n    padding: 10px;\n    width: 50%;\n    background-color: #aacaec;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n\n\n  /* Botón de Añadir */\n.add-user-button {\n    margin-top: 10px;\n    padding: 10px;\n    width: 50%;\n    background-color: #aacaec;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n\n  .add-user-button:hover{\n    background-color: #4d86c3;\n  }\n  .add-group-button:hover{\n    background-color: #4d86c3;\n  }\n  .add-host-button:hover{\n    background-color: #4d86c3;\n  }\n\n  .cancel-button{\n    margin-right: 25px;\n    border-radius: 5px;\n    padding: 8px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
